export default __webpack_public_path__ + "media/assets/img/img_icon_smalltitle-78fe4e42e933564acd71702cabb0a008.svg";